import {html, css, LitElement} from 'lit';
import {customElement} from 'lit/decorators/custom-element.js';
import {connect} from 'pwa-helpers';
import {msg} from '@lit/localize';
import store from '../store';
import style from '../../../scss/footer.scss';
import {getTenantData} from '../../tenants';
import {selectTenant} from '../selectors';

@customElement('arc-footer')
export class Footer extends connect(store)(LitElement) {
	static styles = [style];

	stateChanged(state) {
		this.status = state.status;
		this.tenant = selectTenant(state);
	}

	render() {
		return html`
			<div class="footer">
				<div class="logo">
					<img src="${getTenantData(this.tenant, 'logoInverted')}" alt="${getTenantData(this.tenant, 'name')}" />
				</div>
				<div class="links">
					<a class="link" target="_blank" href="mailto:support@aakio.info">${msg('Help and Support')}</a>
					<a class="link" target="_blank" href="mailto:feedback@aakio.info">${msg('Feedback')}</a>
					<a class="link" target="_blank" href="https://aakio.info">${msg('About AAKIO')}</a>
					<a class="link" target="_blank" href="https://aakio.info/agb">${msg('Terms and Conditions')}</a>
					<a class="link" target="_blank" href="https://aakio.info/impressum">${msg('Imprint')}</a>
				</div>
			</div>
		`;
	}
}
